/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a DNA or RNA sequence to get its reverse complement, complement, or reverse. IUPAC ambiguity codes are handled and FASTA headers, spaces and numbers are ignored.`)
};

const es_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia de ADN o ARN para obtener su complemento inverso, complemento o inverso. Se gestionan los códigos de ambigüedad IUPAC, y las cabeceras FASTA, espacios y números se ignoran.`)
};

const de_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine DNA- oder RNA-Sequenz ein, um ihr reverses Komplement, Komplement oder ihre Umkehrung zu erhalten. IUPAC-Mehrdeutigkeitscodes werden verarbeitet, und FASTA-Header, Leerzeichen und Zahlen werden ignoriert.`)
};

const nl_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een DNA- of RNA-sequentie om het omgekeerde complement, complement of de omkering te krijgen. IUPAC-ambiguïteitscodes worden verwerkt en FASTA-headers, spaties en cijfers worden genegeerd.`)
};

const fr_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence d'ADN ou d'ARN pour obtenir son complément inverse, son complément ou son inverse. Les codes d'ambiguïté IUPAC sont gérés et les en-têtes FASTA, espaces et chiffres sont ignorés.`)
};

const it_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza di DNA o RNA per ottenere il suo complemento inverso, complemento o inverso. I codici di ambiguità IUPAC sono gestiti e le intestazioni FASTA, gli spazi e i numeri vengono ignorati.`)
};

const pt_br2_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de DNA ou RNA para obter seu complemento reverso, complemento ou reversão. Os códigos de ambiguidade IUPAC são tratados e cabeçalhos FASTA, espaços e números são ignorados.`)
};

const pt_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de ADN ou ARN para obter o seu complemento reverso, complemento ou reverso. Os códigos de ambiguidade IUPAC são tratados e cabeçalhos FASTA, espaços e números são ignorados.`)
};

const ja_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNAまたはRNA配列を貼り付けると、逆相補配列、相補配列、逆順配列が得られます。IUPAC縮重コードに対応し、FASTAヘッダー、スペース、数字は無視されます。`)
};

const zh_revcomp_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴 DNA 或 RNA 序列即可获得其反向互补、互补或反向序列。支持处理 IUPAC 简并码，并忽略 FASTA 标题、空格和数字。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_intro", locale)
	if (locale === "en") return en_revcomp_intro(inputs)
	if (locale === "es") return es_revcomp_intro(inputs)
	if (locale === "de") return de_revcomp_intro(inputs)
	if (locale === "nl") return nl_revcomp_intro(inputs)
	if (locale === "fr") return fr_revcomp_intro(inputs)
	if (locale === "it") return it_revcomp_intro(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_intro(inputs)
	if (locale === "pt") return pt_revcomp_intro(inputs)
	if (locale === "ja") return ja_revcomp_intro(inputs)
	return zh_revcomp_intro(inputs)
};